import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { combineLatest } from 'rxjs';

import * as fromDataProviderSelectors from '../../store/selectors/data-provider.selectors';
import * as fromUserSelectors from '../../store/selectors/user.selectors';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard {
  private store = inject(Store);
  private router = inject(Router);

  isGuest = true;
  constructor() {
    combineLatest([
      this.store.pipe(select(fromUserSelectors.selectLoaded)),
      this.store.pipe(select(fromDataProviderSelectors.selectIsAuthenticated))
    ]).subscribe(([loaded, isAuthenticated]) => {
      this.isGuest = !(loaded && isAuthenticated);
    });
  }
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isGuest ? true : this.router.createUrlTree(['property-search']);
  }
}
